import { Box } from '@theme-ui/components';
import type { ThemeUIStyleObject } from '@theme-ui/core';

import { H3 } from '@app/components/typography';
import { isTruthy } from '@app/helpers/predicate';
import { rem } from '@app/styles/theme/layout';

interface ContentBlockProps {
  title: string;
  innerHtml?: string | string[];
  children?: React.ReactNode[];
  sx?: ThemeUIStyleObject;
}

const ContentBlock = ({
  title,
  innerHtml = [],
  children,
  ...props
}: ContentBlockProps) => {
  const htmlContent: string[] = Array.isArray(innerHtml)
    ? innerHtml
    : Array(innerHtml);

  return (
    <Box mb={rem(60)} {...props}>
      <Box sx={{ marginBottom: rem(16) }}>
        <H3 css={{ fontWeight: 500 }} data-testid="content-block-title">
          {title}
        </H3>
      </Box>

      {htmlContent.length > 0 &&
        htmlContent
          .filter(isTruthy)
          .map((content, index) => (
            <Box
              sx={{ lineHeight: 1.5 }}
              key={index}
              data-testid={`content-block-inner-html-${index}`}
              dangerouslySetInnerHTML={{ __html: content }}
            />
          ))}

      {children}
    </Box>
  );
};

export default ContentBlock;
